import join from './join.vue'

export default join
